<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Piegādes adreses</div>
    </div>
  </div>




  <div class="ui segment" v-bind:class="{ loading: storeStatus.loading }">

  <div class="ui warning icon message" v-if="legalAddressError">
    <i class="warning circle icon"></i>
    <div class="content">
    <div class="header">
      Pirms dzēsiet šo adresi, sākumā izvēlieties citu juridisko adresi!
    </div>
  </div>
  </div>
    <div class="ui hidden divider"></div>

    <table class="ui selectable table orange">
      <thead v-if="!checkClientWidth">
        <tr>
          <th>Adrese</th>
          <th>Juridiskā adrese</th>
          <th>Tālrunis kurjeram</th>
          <th>Norādes kurjeram</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items">
          <td>{{item.full_address}}</td>
          <td v-if="item.is_legal_address == 1 && !checkClientWidth">Jā</td>
          <td v-else-if="!checkClientWidth">Nē</td>
          <td>{{item.phone}}</td>
          <td>{{item.notes}}</td>
          <td>
            <button v-on:click="goToEditPage(item)" class="ui custom_brown button">Rediģēt</button>
            <!-- allow delete if there is more than 1 item -->
            <button v-if="items.length > 1" v-on:click="initDeleteAddress(item)" class="ui custom_brown icon button">
            <i class="right trash icon"></i>
          </button>
          </td>

        </tr>
      </tbody>
    </table>
    <router-link :to="{name:'user-address-add'}" class="ui right floated green button"><i class="icon plus"></i>Pievienot adresi</router-link>
    <div class="ui clearing hidden divider"></div>
  </div>
  <!-- delete prompt -->
  <div id="user-address-delete-dialog" class="ui basic modal">
    <div class="ui icon header">
      <i class="trash icon"></i>
      Vai dzēst ierakstu?
    </div>

    <div class="actions">
      <div class="ui grey basic cancel inverted button">
        <i class="remove icon"></i>
        Nē
      </div>
      <div class="ui custom_brown ok inverted button" @click="deleteAddress">
        <i class="checkmark icon"></i>
        Jā
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      itemForDelete:false,
      legalAddressError: false
    }
  },
  computed: {
    items() {
      return this.$store.state.addressStore.items
    },
    storeStatus() {
      return this.$store.state.addressStore.status
    },
    checkClientWidth(){
     return document.documentElement.clientWidth < 768
   },
  },

  activated: function() {
    //reset data
    this.itemForDelete = false;
    this.legalAddressError = false;

    //preload data
    this.$store.dispatch('loadAddress');
  },

  methods: {
    goToEditPage(item){
      this.$router.push({
          name: 'user-address-edit',
          params:{
            id:item.id
          }
      });
    },

    initDeleteAddress(item){

      //check if address is legal and if yes ask to set another legal address
      if(item.is_legal_address == 1) this.legalAddressError = true
      else {
        this.legalAddressError = false;
        this.itemForDelete = item
        $('#user-address-delete-dialog')
          .modal('show');
      }
    },

    deleteAddress: function() {
      this.$store.dispatch('deleteAddress', this.itemForDelete);
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserAddressPage.vue?b93136d2